<script>
	import { Toggle, CodeEditor } from '@shopboxai/sb-portal-components';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
	export let value;

	$: if (value) {
		dispatch('change', value);
	}
</script>

{#each Object.keys(value) as key}
	<div class="app-container">
		{#if typeof value[key] == 'boolean'}
			<Toggle labelText={key} bind:value={value[key]} />
		{:else if typeof value[key] == 'string' || typeof value[key] == 'number'}
			<p>
				{#if typeof value[key] == 'number'}
					<label for={key}>{key} <sup>number</sup></label>
					<input type="number" id={key} bind:value={value[key]} />
				{:else}
					<label for={key}>{key} <sup>text</sup></label>
					<input type="text" id={key} bind:value={value[key]} />
				{/if}
			</p>
		{:else if Array.isArray(value[key])}
			<label for={key}>{key} <sup>array</sup></label>

			<input
				type="text"
				value={value[key]}
				on:input={(e) => {
					value[key] = e.target.value.split(',');
				}}
			/>
		{:else if value[key].lang}
			<label for={key}>{key}</label>
			{#if value[key].lang.toLowerCase() == 'json' && value[key].code}
				<!-- <CodeEditor nestedKeys="locale.code" bind:origin={value} value={value[key].code} /> -->
			{:else if value[key].code}}
				<CodeEditor bind:origin={value[key].code} bind:value={value[key].code} syntax="css" />
			{/if}
		{:else}
			{@const textVal = JSON.stringify(value[key], null, 2)}
			<label for={key}>{key}</label>
			<CodeEditor bind:origin={value[key]} value={textVal} />
		{/if}
	</div>
{/each}

<style>
	div {
		display: grid;
		align-items: center;
		padding: 0.5em 0;
		border-top: 1px solid var(--border-color, #ddd);
	}
	input {
		width: 100%;
		display: block;
		width: 100%;
		padding: 16px 20px;
		border: 2px solid var(--brd-l);
		border-radius: 5px;
		color: var(--t-c);
		font-size: 15px;
		line-height: 1.5;
		margin-bottom: 1em;
	}
	div > :global(*) {
		flex: 1;
	}
	div > :global(.checkbox-wrapper) {
		margin-bottom: 0;
	}
	div :global(.checkbox-wrapper label) {
		text-transform: none !important;
	}
	sup {
		color: #000;
		font-size: 10px;
		opacity: 0.7;
	}
</style>
